:host {
  @include reset-host;
}

:host .social-links {
  display: flex;
  gap: rem(16);
  align-items: center;

  list-style: none;
}
